import React, {Component} from 'react';
import { Async } from 'react-select';
import { Button } from 'react-bootstrap';
import Chart from 'chart.js';
import PropTypes from 'prop-types';
import LeagueAPI from '../../api/LeagueAPI';

class StatsQueryHome extends Component {
  constructor(props){
    super(props);
    this.getPlayerOptions = this.getPlayerOptions.bind(this);
    this.getTeamOptions = this.getTeamOptions.bind(this);
    this.getTournamentOptions = this.getTournamentOptions.bind(this);
    this.getSeriesOptions = this.getSeriesOptions.bind(this);
    this.generateTable = this.generateTable.bind(this);
    this.state = {
      player: null,
      team: null,
      series: null,
      tournament: null,
    };
  }

  getPlayerOptions(input) {
    return LeagueAPI.getPlayerAutocomplete({ search: input }).then(
      (resp) => {
        const options = resp.data.results.map(
          (p) => { return { value: p.id, label: p.ign }; }
        );
        return { options };
      },
    );
  }

  getTeamOptions(input) {
    return LeagueAPI.getTeamAutocomplete({ search: input }).then(
      (resp) => {
        const options = resp.data.results.map(
          (p) => { return { value: p.id, label: p.name }; }
        );
        return { options };
      },
    );
  }

  getTournamentOptions(input) {
    return LeagueAPI.getTournamentAutocomplete({ search: input }).then(
      (resp) => {
        const options = resp.data.results.map(
          (p) => { return { value: p.id, label: p.name }; }
        );
        return { options };
      },
    );
  }

  getSeriesOptions(input) {
    return LeagueAPI.getSeriesAutocomplete({ search: input }).then(
      (resp) => {
        const options = resp.data.results.map(
          (p) => { return { value: p.id, label: p.name }; }
        );
        return { options };
      },
    );
  }

  generateTable() {
    // This should generate a table based on the filters above.
  }

  render() {
    const { player, team, tournament, series } = this.state;
    console.log(player);
    return (
      <div>
        <h1>Stats Query</h1>
        <label>Player Filter</label>
        <Async
          loadOptions={this.getPlayerOptions}
          value={player}
          onChange={val => this.setState({ player: val && val.value })}
          disabled={team}
        />
        <label>Team Filter</label>
        <Async
          loadOptions={this.getTeamOptions}
          value={team}
          disabled={player}
          onChange={val => this.setState({ team: val && val.value })}
        />
        <label>Series Filter</label>
        <Async
          loadOptions={this.getSeriesOptions}
          value={series}
          disabled={tournament}
          onChange={val => this.setState({ series: val && val.value })}
        />
        <Button onClick={this.generateTable}>Generate Table</Button>
        <Button onClick={this.generateGraph}>Generate Graph</Button>
      </div>
    );
  }
}

StatsQueryHome.propTypes = {};
StatsQueryHome.defaultProps = {};

export default StatsQueryHome;



// WEBPACK FOOTER //
// ./src/cms/stats/StatsQueryHome.js